export default "__VITE_ASSET__$AazQC48__"